import { ForwardedRef, forwardRef } from "react";

import { IntakeFormSection } from "@smart/bridge-intake-components-dom";

import { GqlField, GqlGroup, GqlSection } from "../../types";

export type FormPrintContentProps = {
  formTitle?: string;
  sections?: GqlSection[] | null;
  groups?: GqlGroup[] | null;
  fields?: GqlField[] | null;
};

export const FormPrintContent = forwardRef(
  (
    { formTitle, sections, groups, fields }: FormPrintContentProps,
    forwardedRef: ForwardedRef<HTMLDivElement>,
  ) => {
    if (!sections || !groups || !fields) return null;

    const visibility = {
      visibleFields: fields.reduce(
        (acc, field) => {
          acc[field.values.uri] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      ),
      visibleGroups: groups.reduce(
        (acc, group) => {
          acc[group.values.uri] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      ),
      visibleSections: sections.reduce(
        (acc, section) => {
          acc[section.values.uri] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      ),
      visibleRepeatableFields: fields.reduce(
        (acc, field) => {
          acc[field.values.uri] = [true];
          return acc;
        },
        {} as Record<string, boolean[]>,
      ),
      willBeHidden: () => [],
    };

    return (
      <div hidden data-testid="form-print-content">
        <style>
          {`
          @media print {
            @page {
              margin: 20px 0px;
            }
          }
        `}
        </style>
        <div className="print:m-0 print:block" ref={forwardedRef}>
          <div className="text-h1 font-poppins font-semibold ml-[7rem] mt-[4rem]">
            {formTitle}
          </div>
          {sections.map((section) => (
            <IntakeFormSection
              visibleSections={sections}
              selected={section.values}
              groups={groups.map((group) => group.values)}
              fields={fields.map((field) => field.values)}
              onSelect={() => {}}
              onSummary={() => {}}
              loadResponses={() => Promise.resolve({})}
              submitResponses={() =>
                Promise.resolve({
                  operationIds: [],
                  submissionStatus: { status: "active" },
                })
              }
              setResponses={() => {}}
              setStatus={() => {}}
              team={{ name: "" }}
              sidebar={false}
              setSidebar={() => {}}
              responses={{}}
              visibility={visibility}
              setVisited={() => {}}
              staffDetails={[]}
              uploadFileProps={{
                onProgress: () => {},
                onUploadStatusChange: () => {},
                getUploadState: () => ({ uploading: false, progress: 0 }),
                remove: () => {},
              }}
              addressLookup={{
                search: () => ({}),
                load: () => Promise.resolve({}),
              }}
              fileLookup={{
                load: () => Promise.resolve([]),
                upload: () => ({ promise: Promise.resolve(), abort: () => {} }),
              }}
              isPrint
              completeFormOrRedirect={() => {}}
              beginDigitalSignatureWait={() => {}}
              attemptDigitalSignatureRecovery={() => Promise.resolve()}
            />
          ))}
        </div>
      </div>
    );
  },
);
